import { Fragment } from 'react';
import { cropName } from '../../../../lib/crops';

/** Культуры одного года по порядку: «Хлопок → Пшеница». Одна культура — просто имя. */
export function cropChainText(codes: readonly string[]): string {
  return codes.map((code) => cropName(code)).join(' → ');
}

export function CropChain({ codes }: { codes: readonly string[] }) {
  return (
    <span className="fld-chain">
      {codes.map((code, index) => (
        <Fragment key={code}>
          {index > 0 ? <span className="fld-chain__arrow">→</span> : null}
          <span>{cropName(code)}</span>
        </Fragment>
      ))}
    </span>
  );
}
